import * as Yup from "yup";

export const signUpSchema = Yup.object().shape({
  name: Yup.string().required("Please enter team name").trim(),
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
  number: Yup.string().matches(
    /^[0-9]{10,15}$/,
    "Mobile number must be between 10 abd 15 digits"
  ),
  password: Yup.string()
    .required("Please enter password")
    .min(8, "Password cannot be less then 8 characters"),
  // .matches(
  //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
  //   "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
  // ),
  confirm_password: Yup.string()
    .required("Please enter confirm password")
    .oneOf([Yup.ref("password"), null], "Your password must match"),
});

export const signInSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
  password: Yup.string()
    .required("Please enter password")
    .min(8, "Password cannot be less then 8 characters"),
  // .matches(
  //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
  //   "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
  // ),
});

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
});

export const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .required("Please enter your current password")
    .min(8, "Current Password cannot be less then 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
      "Please enter a valid password"
    ),
  newPassword: Yup.string()
    .required("Please enter new password")
    .min(8, "New Password cannot be less then 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
      "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
    ),
  confirmPassword: Yup.string()
    .required("Please enter confirm password")
    .oneOf([Yup.ref("newPassword"), null], "Your password must match"),
});

export const updateProfileSchema = Yup.object().shape({
  name: Yup.string().required("Please enter name").trim(),
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
  number: Yup.string()
    .matches(/^[0-9]{10,15}$/, "Mobile number must be between 10 abd 15 digits")
    .required("Please enter a mobile number"),
});

export const reviewSchema = Yup.object().shape({
  // name: Yup.string().required("Please enter name").trim(),
  // email: Yup.string()
  //   .trim()
  //   .email("Please enter a valid email")
  //   .required("Please enter email")
  //   .matches(
  //     /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
  //     "Please enter a valid email"
  //   ),
  review_text: Yup.string().required("Please enter a your review"),
  rating: Yup.string().required("Please enter rating"),
});
export const contactUsSchema = Yup.object().shape({
  name: Yup.string().required("Please enter full name").trim(),
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
  subject: Yup.string().required("Please enter a subject"),
  message: Yup.string().required("Please enter a your message"),
});

export const basicDetailSchema = Yup.object().shape({
  profile_image: Yup.mixed().test(
    "fileOrUrl",
    "Please upload a valid image",
    (value) => {
      if (!value || typeof value === "string") return true; // Allow existing URL or no file
      const validFileTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];
      return validFileTypes.includes(value.type);
    }
  ),
  name: Yup.string().trim().required("Please enter team name"),
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
  number: Yup.string()
    .matches(/^[0-9]{10,15}$/, "Number must be between 10 abd 15 digits")
    .optional(),
  designation: Yup.string().trim().nullable().notRequired(),
  website_link: Yup.string().trim().nullable().notRequired(),
  discord_name: Yup.string().trim().nullable().notRequired(),
  about: Yup.string()
    .trim()
    .max(255, "Description must be at most 255 characters")
    .nullable()
    .notRequired(),
  password: Yup.string()
    .min(8, "Password cannot be less then 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
      "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
    )
    .optional(),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Your password must match")
    .optional(),
});
export const editBasicDetailSchema = Yup.object().shape({
  profile_image: Yup.mixed().test(
    "fileOrUrl",
    "Please upload a valid image",
    (value) => {
      if (!value || typeof value === "string") return true; // Allow existing URL or no file
      const validFileTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];
      return validFileTypes.includes(value.type);
    }
  ),

  name: Yup.string().required("Please enter team name").trim(),
  tournament: Yup.string().trim().nullable().notRequired(),
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
  number: Yup.string()
    .matches(/^[0-9]{10,15}$/, "Number must be between 10 abd 15 digits")
    .optional(),
  designation: Yup.string().trim().nullable().notRequired(),
  website_link: Yup.string().trim().nullable().notRequired(),
  discord_name: Yup.string().trim().nullable().notRequired(),
  about: Yup.string().trim().nullable().notRequired(),
  password: Yup.string()
    .optional()
    .min(8, "Password cannot be less then 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
      "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
    ),
  confirm_password: Yup.string()
    .optional()
    .oneOf([Yup.ref("password"), null], "Your password must match"),
});

export const addBotSchema = Yup.object().shape({
  image: Yup.mixed().test(
    "fileOrUrl",
    "Please upload a valid image",
    (value) => {
      if (!value || typeof value === "string") return true; // Allow existing URL or no file
      const validFileTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];
      return validFileTypes.includes(value.type);
    }
  ),
  name: Yup.string().required("Please enter bot name").trim(),
  start_date: Yup.date().nullable().required("Please select a date"),
  description: Yup.string()
    .trim()
    .max(255, "Description must be at most 255 characters")
    .nullable()
    .notRequired(),
});
